import { z } from 'zod'
import { sanitizeRestrictedLabelText } from '@/lib/utils/displayText'

/** Letters, numbers, spaces, and - . _ , ( ) / & — no apostrophe (') or plus (+). */
export const RESTRICTED_LABEL_REGEX = /^[A-Za-z0-9\s\-._,()\/&]*$/

export const RESTRICTED_LABEL_MESSAGE =
  "Only letters, numbers, spaces, and - . _ , ( ) / & are allowed. Apostrophe (') and plus (+) are not allowed."

export function sanitizeRestrictedLabelInput(value: string | null | undefined): string {
  return sanitizeRestrictedLabelText(value ?? '')
}

/** Required division/catalog label field (name, code). */
export const restrictedLabelRequired = z
  .string()
  .min(1, 'This field is required')
  .transform(sanitizeRestrictedLabelInput)
  .refine((v) => v.length > 0, { message: 'This field is required' })
  .refine((v) => RESTRICTED_LABEL_REGEX.test(v), { message: RESTRICTED_LABEL_MESSAGE })

/** Optional label/description field with same character rules. */
export const restrictedLabelOptional = z
  .string()
  .optional()
  .nullable()
  .transform((v) => {
    if (v == null || v === '') return v === '' ? '' : null
    return sanitizeRestrictedLabelInput(v)
  })
  .refine((v) => v == null || v === '' || RESTRICTED_LABEL_REGEX.test(v), {
    message: RESTRICTED_LABEL_MESSAGE,
  })
